module.exports = __webpack_public_path__ + "images/aller-national-logo-black_8e92508ac201f331b3548630ba9d1b4c.svg";